// Where public content comes from.
//
// REACT_APP_CONTENT_SOURCE=api   the published portfolio from /api/content
// anything else (the default)    the data files bundled with the site
//
// The two are exclusive at build time. With the api source the legacy data
// is not part of the build at all, so a failing API can never bring back
// content that has since been unpublished or deleted.
export const USE_API = process.env.REACT_APP_CONTENT_SOURCE === 'api';

export const bundledContent = process.env.REACT_APP_CONTENT_SOURCE === 'api' ? null : require('./legacy').content;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function isContent(value) {
  return Boolean(value) && Array.isArray(value.projects) && Array.isArray(value.fineArts);
}

// Two quick retries, then give up. The caller shows "unavailable"; it never
// falls back to anything older.
export async function fetchPublicContent() {
  let lastError;
  for (const delay of [0, 400, 1200]) {
    if (delay) await wait(delay);
    try {
      const response = await fetch('/api/content', { headers: { Accept: 'application/json' } });
      if (response.ok) {
        const body = await response.json();
        if (isContent(body)) return body;
      }
      lastError = new Error(`Content request failed with status ${response.status}`);
    } catch (err) {
      lastError = err;
    }
  }
  throw lastError;
}
